<template>
	<div class="link">
		<breadcrumb></breadcrumb>
		<div class="link-content">
			<el-row :gutter="30">
				<el-col :span="18">
					<div class="main-box-link">
						<tpl-link :getLinkInfo="getLinkInfo" :linkInfo="linkInfo" v-if="linkInfo"></tpl-link>
						<div class="link-body" v-if="showPage">
							<!-- "文档" "音视频" "活动图片"-->
							<!-- <link-file :linkInfo="linkInfo" v-if="['image','document','media'].includes(linkInfo.nodeType)"></link-file> -->
							<!-- 讨论 在线笔记 培训体会 课题总结 课题收获 -->
							<link-talk :linkInfo="linkInfo"  v-if="['speak','note','experience','harvest','summary'].includes(linkInfo.nodeType)"></link-talk>
							<!-- 评价 -->
							<link-eva :linkInfo="linkInfo" v-if="['eval'].includes(linkInfo.nodeType)"></link-eva>
							<!-- 问卷 -->
							<link-ques :linkInfo="linkInfo" v-if="['survey'].includes(linkInfo.nodeType)"></link-ques>
							<!-- 培训作业 -->
							<link-work :linkInfo="linkInfo" v-if="['homework'].includes(linkInfo.nodeType)"></link-work>
						</div>
					</div>
				</el-col>
				<el-col :span="6">
					<div class="menu-box">
						<tpl-detail titName="活动环节">
							<template slot="body">
								<ul>
									<li v-for="(item,i) in linkInfoList" :key="item.id" :class="activeNodeCode==item.nodeCode ? 'active clearfix':'clearfix' " @click="changeLinkType(item)">
										<span class="name">{{i+1}} {{item.nodeTypeDesc}}</span>
										<div class="desc fl">{{item.topic}}</div>
									</li>
								</ul>
							</template>
						</tpl-detail>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState } from "vuex";
import breadcrumb from "@/components/Breadcrumb.vue";
import TplDetail from "@/templates/TplDetail.vue";
import TplLink from "@/templates/TplLink.vue";
import LinkFile from "@/components/link/LinkFile.vue";
import LinkTalk from "@/components/link/LinkTalk.vue";
import LinkEva from "@/components/link/LinkEva.vue";
import LinkQues from "@/components/link/LinkQues.vue";
import LinkWork from "@/components/link/LinkWork.vue";
export default {
	components: {
		breadcrumb,
		TplDetail,
		TplLink,
		LinkFile,
		LinkTalk,
		LinkEva,
		LinkQues,
		LinkWork
	},
	computed: {
		...mapState(["userInfo"])
	},
	data() {
		return {
			activeNodeCode: "",
			linkInfoList: [],
			linkInfo: "",
			showPage: true
		};
	},
	created() {
		this.init();
	},
	methods: {
		async init() {
			//moduleType: "" //eduResearch 教研活动 	train 培训  topicResearch 项目课题研究
			let moduleUrl;
			if (this.$route.query.moduleType === "eduResearch") {
				moduleUrl = "research";
			} else if (this.$route.query.moduleType === "train") {
				moduleUrl = "training";
			} else if (this.$route.query.moduleType === "topicResearch") {
				moduleUrl = "topic";
			}
			console.log("moduleUrl", moduleUrl);
			this.linkInfoList = await getData(
				"/" + moduleUrl + "/getActiveNodeTopicList",
				{
					actCode:
						moduleUrl === "topic"
							? sessionStorage.getItem("actLinkCode")
							: sessionStorage.getItem("actCode"),
					isSub: moduleUrl === "topic" ? 1 : 0 //是否是子活动节点，0：否，1：是     只有项目课题研究是1
				}
			);
			this.activeNodeCode = this.$route.query.nodeCode;
		},
		changeLinkType(item) {
			this.$router.push({
    query: {...this.$route.query, nodeCode:item.nodeCode}
})
			this.activeNodeCode = item.nodeCode;
		},
		async getLinkInfo(nodeCode){
			this.showPage = false;
				this.linkInfo = await postData("/node/getActiveNodeTopic", {
					actCode: sessionStorage.getItem("actCode"),
					nodeCode: nodeCode,
					operateId: this.userInfo.userId,
          schoolCode: this.userInfo.orgCode || this.userInfo.schoolCode
				});
				this.showPage = true;
		}
	},
	watch: {
		activeNodeCode: {
			async handler(val) {
				await this.getLinkInfo(val)
			}
		}
	}
};
</script>

<style lang="less" scoped>
.link {
	// padding: 10px 20px;
	.link-content {
		margin-top: 15px;
		.main-box-link {
			.link-body {
				margin-top: 20px;
				padding: 2px;
				padding-bottom: 0px;
				// border: 1px solid #000;
			}
		}
		.menu-box {
			ul {
				padding-left: 0px;
				li {
					border-bottom: 1.8px solid #eee;
					cursor: pointer;
					padding: 8px 0px;
					display: table;
					.name {
						width: 90px;
						text-align: left;
						font-size: 18px;
						font-weight: 700;
						vertical-align: middle;
						display: table-cell;
					}
					.desc {
						border-left: 2px solid #eee;
						font-size: 13px;
						margin-left: 7px;
						padding-left: 8px;
						font-size: 12.5px;
						font-weight: 700;
					}
				}
				li:nth-of-type(1) {
					border-top: 1.8px solid #eee;
				}
				li:hover {
					color: @color;
				}
				.active {
					color: @color;
				}
			}
		}
	}
}
</style>
